import store from "../store"

const defaultState = {
    success: undefined,
    loading: false
} 

const authReducer = (state = defaultState, action) => {
    switch(action.type) {
        case "POST_CONTACTS_RESET":
            return { success: undefined }
        case "POST_CONTACTS_REQUEST": 
            return { success: undefined, loading: true }
        case "POST_CONTACTS_FAILED":
            return { success: false, loading: false }
        case "POST_CONTACTS_SUCCESS":
            return { success: true, loading: false }
        default:
            return state;
    }
}

export default authReducer;